import OpenX from '@module/openx';
import { actions } from '@app/action/user';
import defaultUser from '@app/store/helper/user';

import Transform from '@app/transformers';

export default function(state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_USER: {
      const transformedDetails = Transform.user(action.details);
      const {
        id,
        full_name,
        email,
        profile_picture,
        language,
        memberships,
        storageFull,
      } = transformedDetails;

      return {
        ...state,
        loggedIn: id || false,
        storageFull,
        full_name,
        email,
        profile_picture,
        language,
        memberships,
      };
    }

    case actions.CHANGE_USER_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };

    case actions.SIGNIN_SUCCESS: {
      OpenX.setLoggedIn(true);

      const {
        id,
        email,
        full_name,
        profile_picture,
        language,
        preferences,
        memberships,
      } = action.details;

      return {
        ...state,
        loggedIn: id,
        id,
        email,
        full_name,
        profile_picture,
        language,
        preferences,
        memberships,
      };
    }

    case actions.SIGNOUT_SUCCESS:
      OpenX.setLoggedIn(false);

      return {
        ...state,
        loggedIn: false,
      };

    // PASSWORD (Request/Reset)
    case actions.REQUEST_PASSWORD_RESET_SUCCESS:
    case actions.PASSWORD_RESET_SUCCESS:
      return {
        ...state,
      };

    case actions.RESET_USER_STATE:
      return {
        ...defaultUser,
        loggedIn: false,
      };
  }

  return state;
}
